import { FastLaneProvider } from '../application/ports/FastLaneProvider';
import store from '../store';

export class FastLaneAdapter implements FastLaneProvider {
  getFastLane() {
    return store.getState().abTesting?.fastLaneTesting ?? null;
  }
}
